module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Draycott Everlasting")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "application/xhtml+xml; charset=utf-8",
      "http-equiv": "content-type"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe-page-template+xml"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("PROLOGUE")])])])])]), _c('p', {
    staticClass: "chapterDateline"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Glenbrae House"), _c('br'), _vm._v("\nGlenbrae, Scotland"), _c('br'), _vm._v("\nEarly summer")])])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', [_vm._v("H"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("OPE")])]), _vm._v(" O’H"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("ARA CLENCHED")])]), _vm._v(" her fists to keep from trembling.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Scotland.")])]), _vm._v(" Brooding and magical.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Green hills rippled before her, densely wooded above a pristine loch. Sunlight cast a glow over sharp slopes, chasing away wisps of early morning mist.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("High hills full of legends and ghosts.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A tremor raced through her, swift and sharp. Suddenly Hope had the sense that something rare and momentous was about to happen, something meant only for her to see and share.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Sunlight shifted.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Mist swayed.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Since her eighteenth birthday her uncle had urged her to visit this green glen. Hope was sorry her visit had come only after his death. There had always been some delay or prior commitment. And then it had been too late.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her eyes blurred for a moment as she remembered her uncle’s noisy laughter and interminable bad jokes. During a book research trip Dermot O’Hara had fallen in love with Glenbrae, assuring Hope that she would, too. How right he had been. She only wished he were here to share it with her now.")])])]), _c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("No regrets, girl.")])]), _vm._v(" His booming voice seemed to sweep out of the shadows to comfort her. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Get on with living.")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("When Hope saw the rugged tower house that loomed beyond the banks of the loch, her pulse tripped. Against all logic or explanation, each stone felt familiar. Just as before, she had the sudden sense that time was reaching out to her, offering all its mysteries.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("If only she were brave enough to take them.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A beam of Highland sunshine peeked through the racing mist, burning over the tarnished letters on the front door.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Glenbrae House.")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("So beautiful. But why was it somehow…familiar?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A chipped flagstone path ran past the first early roses, an explosion of pink, peach and fuchsia. Below the thatched roof, sunbeams lit hundreds of fragile leaded-glass panels. It was like a dozen other old buildings Hope had seen since coming to Scotland two weeks before. All had been full of broody atmosphere tinged with magic.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But Glenbrae House was different. Personal, almost. She felt as if she were at home.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("As if in a trance, Hope walked closer, feeling her heart race. The original house was thirteenth century, the estate agent now waiting in the car had explained, a traditional Scottish tower structure built for a local branch of the MacLeod clan. When the family fortunes had declined in the last century, a band of pre-Raphaelites had bought the property and turned the lower floors into painting studios.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("They had felt the magic, too. Hope had seen some of their luminous illustrations of Glenbrae’s weathered gray walls exploding with summer roses. Warriors rode through the deep woods, and faeries seemed to peek from beneath green bowers.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Legends lay everywhere. Magic touched every shadow.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("In silence the house called to her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("How could she resist?")])])]), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She brushed back a vine and pushed open the front door, half expecting to see ghostly figures drift past her shoulder. But her footsteps echoed through the empty rooms. Only dusty motes danced over the scuffed wood floors.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Lonely,")])]), _vm._v(" the house seemed to whisper. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("So lonely.")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But it took little imagination for Hope to envision bolder days when hardened travelers in heavy kilts gathered by open fires that blazed in the great hall. Here battles were plotted and history planned. Even the smoke on the stones whispered to her, holding cherished fragments of Scotland’s stormy past.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Ghosts, some would call them. But Hope had never feared ghosts. Since childhood she had walked with ghosts, and history had been her greatest love, along with the beautiful books that captured its legends. And right now she stood shivering, breathless, drowning in history.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Because every corner of Glenbrae House felt like home.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The house seemed to shift and whisper, breaking the silence. Perhaps because she had become accustomed to the sounds of loneliness at an early age, she found herself listening to those low whispers. The shadows did not scare her, nor did the grime she saw.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She had once been awkward and quiet. Even as a child she had been too grave to suit those her own age, and she still didn’t fit in. While others her age were busy lining up stock options, mutual funds and a collection of summer homes, Hope was still wandering. Six months in the Aegean and a season in Milan. Even a year spent teaching basic English in a lonely mountain village in western China.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Always searching. Always looking for magic and the right place to put down roots.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('span', [_vm._v("Now there was no family to hold her. Mother, father, uncle—Hope had lost them one by one. She only occasionally remembered her mother’s breathless laugh or her father’s slow smile. A boating accident had caught them ")])]), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_vm._v("during a summer storm on the Aegean the year that Hope turned thirteen. She had been convinced she could not survive, but she had, largely through the unswerving optimism of her boisterous uncle. Dermot O’Hara had soon become father and mother, guardian and friend. He had made her laugh and he had taught her to dream.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('span', [_vm._v("And Hope dreamed now.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('span', [_vm._v("Of sunny rooms and Christmas carols on a snowy night. Of a house that would soon become a home.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('span', [_vm._v("Not that the job would be easy. Glenbrae House had stood empty for almost twenty years, and sunlight dappled the chipped, gouged floors. Marks of disrepair were everywhere.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('span', [_vm._v("In the great hall, high, cantilevered beams bore tracks of soot from centuries of peat smoke. But instead of grime, Hope saw hard-eyed warriors who warmed their hands by the roaring flames.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('span', [_vm._v("The great house whispered, teasing with ancient secrets. Outside, the wind rustled the hedges and shook the rose shrubs as springtime fragrance spilled through an open window, heady and rich. Around the loch, wildflowers dotted the hills and danced in the sun. It would be hard work to bring the grounds back to their pristine beauty, but Hope had never been afraid of hard work.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('span', [_vm._v("Of other things, but not work.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('span', [_vm._v("She stared out the window at the shifting silver water of the loch, feeling Glenbrae’s beauty seep into her weary, wounded soul.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('span', [_vm._v("She had traveled long enough. Maybe here along the rocky banks of Loch Glenbrae in a fortified thirteenth-century stone tower house with eight-foot-thick walls and a roof that probably leaked, she could finally put down roots.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_c('span', [_vm._v("With her uncle’s death had come a small legacy and the promise of more in the future. Hope knew he would like nothing more than for her to be settled here between the peaceful green hills.")])])]), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Above her head, a bar of sunlight swept the turret stair. Her breath caught as light brushed the dim outline of a painting worked over the plaster at the turn of the stairs. A warrior in flowing hauberk and chain mail glared down at her, pride and arrogance set in every angular feature.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A MacLeod, no doubt. A warrior by the look of him. A man of duty and granite honor.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("With the changing light, he seemed to waver, an apparition from a Highland dawn.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Somehow, he, too, seemed familiar.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Hope told herself it was imagination, run amok after hours of travel over pitted roads. But the loch-gray eyes seemed to follow her movements, questioning her right to enter his shadowed domain.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She stood rooted to the spot, fighting the challenge of that keen gaze.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Even as her logic counseled her to flee, her heart stirred. She was crazy to be here, crazy to spin fantasies of belonging in a house at the edge of nowhere. The repairs alone would cost a fortune. But Hope felt linked with this house, as if she were no longer free to leave the beautiful old halls so much in need of tender hands and loving repair.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She stretched trembling fingers to the dim painting, half expecting to feel warm skin and rigid muscle through the cold textures of plaster and paint.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But there was no warmth, of course. No life behind the cold eyes.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Yet still the painting held her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Let me go,” she whispered.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Around her the shadows moved. The room carried the echo softly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Then at least give me your whole name. Which MacLeod are you?” Softly, her words swept the empty room.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("WhichMacLeodwhichMacLeodwhichMacLeod.")])])])])]), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A car horn blared outside. Hope shivered and turned toward the door.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The agent had another house for sale on the far side of the valley. Something new and tidy, closer to the village and in need of little upkeep.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Yes, that was the sensible thing. But she didn’t want to be sensible.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Wind scurried over her shoulder, tugging at her hair. Threadbare lace curtains fluttered at a broken window.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Then the front door slammed shut, closing her in, shuttering the room in darkness. With a gasp, Hope spun around. Light played over the figure above the staircase, where the keen, misty eyes glinted, filled with challenge—and just a hint of humor.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Very funny, tough guy. Just don’t think you’re going to scare me into leaving.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The scent of roses filled the air, and Hope imagined how the house would look filled with candles and warmed with laughter. She knew from personal experience that there was no inn within thirty miles of Glenbrae. And she would have all these empty rooms…")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("An inn. A period inn that clung defiantly to its history and authenticity. Tartans on the walls. Laughter amid shadows and crackling fires on a gusty night, a haven for weary travelers.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her breath caught. She rubbed the bank check in her pocket, the first installment of the legacy from her beloved uncle.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Don’t talk to me about miracles, girl,")])]), _vm._v(" Dermot O’Hara had always said. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Go out and make your miracles happen all by yourself.")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Hope could work a miracle here. This ruined, beautiful house in a quiet corner of the Highlands was a place to make dreams and put down roots. And maybe here she would finally heal from the heartbreak of losing her family.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Wind whispered down the high chimney, stirring the fine hairs at her neck. Almost like a greeting, Hope thought.")])])]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She sent a saucy glance to the painting. The warrior’s eyes seemed to glint back at her, bright with challenge.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Hope laughed softly, swept by a sudden illogical sense of adventure. “Better make some room, MacLeod. Looks like you’re going to have to share.”")])]), _c('p', {
    staticClass: "spaceBreak"
  }, [_c('span')]), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('span', [_vm._v("C"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("HINTZ CURTAINS TWITCHED")])]), _vm._v(" at the front window of a tiny cottage just beyond the loch. Three white-haired heads bobbed at the leaded panes.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I told you so! See how she’s following the path.” Perpetua Wishwell, the eldest of the three sisters, pointed over the glen. “Look, she’s going inside.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her sister, Honoria, the middle sister and the plumpest of the three, gave a quick laugh. “She’s taken down the sales sign. She’s going to stay. I can almost feel it.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“She looks very nice.” Morwenna Wishwell gave a thoughtful frown. “American, do you think?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Honoria nodded briskly. “From a place called Chicago. I think she’s the one we’ve been waiting for.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Morwenna toyed with a silver pin of a cat staring up at a full moon. “It’s the correct planetary alignment. The moon in Libra—a very good time for establishing roots and turning a house into a home. What do you think, Perpetua?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The tallest of the three, Perpetua tapped one finger against her rather pointed chin. “She looks too slender. Too young. What if the house proves too much for her? The past hangs heavy there. And we all know that the thatched roof leaks terribly. She might not be up to this.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“She is,” Honoria said quietly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“What about the dilapidated kitchen? One sight of that stove would make a strong man run for cover. And we still don’t know her name.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Hope O’Hara,” Honoria answered quickly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Irish?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('span', [_vm._v("“Irish, German and Spanish,” her sister corrected. ")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("“Even some obscure Russian ancestor who settled in a place called Duluth.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("“Never mind Duluth.” Perpetua frowned. “If you ask me, she’s too fragile to tackle the manor. One good wind will knock her down.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("“Nonsense,” Honoria snapped. “I’ve done her chart. She "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("belongs")])]), _vm._v(" in the manor house. I did her transits after I got her birth date from that nice young man who was driving the loan car for the estate agent.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("The shrill blast of a horn cut through the air.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("The sisters pressed closer to the window. Morwenna murmured a low, inaudible phrase and stroked the silver cat pin. “She is very vulnerable right now. She’s lost her uncle, I believe. And her parents, too. But there’s something else…something physical that troubles her deeply.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("“What sort of trouble?” Honoria demanded.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("“I can’t see.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("“Hmm. What she needs is a vacation,” Honoria said sagely.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("Morwenna’s eyes turned speculative. “What she "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("needs")])]), _vm._v(" is a man.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("“A man?” Perpetua’s eyes narrowed, almost catlike.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("“A man of honor, of course. An ally and companion. Someone who doesn’t mind hard work. Restoring Glenbrae House is going to be a labor to task Hercules, believe me.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("“Unfortunately, Hercules is unavailable at the moment.” Perpetua smiled faintly. “But hard work would mean nothing to the right man. A man who doesn’t know the softness of a woman’s laugh or the heat of her skin. A man who has been too long from home, too long on the move.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("“You have someone in mind?” Honoria said eagerly.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("“Possibly.” Perpetua’s head tilted. Light gleamed over her snowy hair. “Yes, quite possibly the perfect man.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("Morwenna sat up straighter as an image swept into her mind. “Not "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("him.")])]), _vm._v(" The man’s dead inside.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("No answer.")])])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Perpetua, you’re not listening to me. Ronan MacLeod is a "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("soldier.")])]), _vm._v(" Any woman in his life will be merely a night’s diversion.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“That might change,” Honoria said slowly. “With the right woman beside him. Someone to soften the past.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“It would take a ton of steel wool to soften "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("his")])]), _vm._v(" past.” Morwenna shook her head. “All he has known is war and loss since the first moment his father put a bow in his hand, cuffed him and told him to meet his mark or he’d see that the whole village went hungry that night.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A frown crossed Perpetua’s smooth brow. “A crude man, Angus MacLeod. Such a pity the mother died so young. But that changes nothing. Ronan MacLeod is the one.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Morwenna’s fingers moved restlessly. “He’s as hard as the steel of that weathered broadsword he values more than life. And the things he’s done…”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Perpetua shrugged. “He is a man of honor. On that, you’ll agree.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Morwenna nodded reluctantly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“And he is capable of the most arduous campaign.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Another nod.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Then it’s settled. Ronan MacLeod will do very well for our Miss O’Hara.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“But they’ll be like oil and water. He’s positively medieval. And she’s so—modern.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I think we should have a look,” Perpetua said abruptly. In silence their fingers linked. “In and out quickly, mind you. We don’t want him to sense anything,” Perpetua whispered.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She raised her hands to her sisters. The thrush song faded away and silence gathered, deep and oppressive. Around them the room receded as the shadows thickened.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("A figure slowly took shape in the semidarkness. His eyes were hard, the flat gray of a mountain loch in winter. Sunlight gleamed from the plate armor at his chest and his ")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("dented broadsword. Behind him stretched muddy paths and the thatched roofs of a country town.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', [_vm._v("Glenbrae Village, as it had been in early spring, seven centuries in the past.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', [_vm._v("Perpetua murmured in satisfaction. “Careful,” she cautioned as their thoughts began to link and expand outward. “If he senses us, he’ll put up resistance, and that will make our next contact much harder.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', [_vm._v("Honoria frowned. “He’s smarter than he looks. And he’s more dangerous. Dear me, maybe we "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("should")])]), _vm._v(" reconsider our plan…”")])])]), _c('p', {
    staticClass: "spaceBreak"
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span')])]), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', [_vm._v("R"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("ONAN")])]), _vm._v(" M"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("AC")])]), _vm._v("L"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("EOD SLID")])]), _vm._v(" from his weary horse and rubbed the back of his neck. Endless hills stretched before him like restless seas, rich and green.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', [_vm._v("Endlessly different from the landscape he had known for the past years as a Crusader in the burning sands of the East. “Do you sense that we’re being watched?” he asked his page.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', [_vm._v("“Aye, my liege. The whole town has come to watch the King’s Wolf ride in.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', [_vm._v("“Not that,” MacLeod said slowly. “Closer. And yet not close at all. It is most…strange.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', [_vm._v("The page shrugged, well used to his master’s flights of fancy. “I see nothing but muddy streets full of curious villagers, my lord.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', [_vm._v("Ronan MacLeod surveyed the rugged green slopes. Long years of warfare had given him an instinct for danger he had learned never to ignore, but the muddy streets posed no threat that he could detect. There were no armed Saracens crouched behind the half-timbered walls. No plotting courtiers hid behind the baker’s ovens.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', [_vm._v("Yet still the odd sense of uneasiness persisted.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('span', [_vm._v("He smiled bitterly at the grim little hamlet before him. Who would not feel unease in such a place? Glenbrae looked primitive and rude after the colorful cities he had ")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("passed in the East on his way to the Crusades. He had heard the bells of Paris toll from the greatest of the cathedrals. He had eaten the finest of roast swan with his fellow knights in Champagne and Burgundy. He had hawked on the slopes of the Pyrenees and savored the colors of a hundred kinds of silk in the teeming markets of Damascus. Through it all, he had fought for a king and felt a thousand times as if he were drowning in the blood of war.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("Now Ronan MacLeod had come home—home to a narrow, muddy little hole in the hills known as Glenbrae.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("If one could call a dozen stone cottages huddled in the shadow of a glen home.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("He pulled a roll of parchment from beneath his hauberk and fingered the red ribbon threaded through the document. From the ribbon hung a wax seal with the image of his sovereign lord, Edward. “For loyalty in right trusty service in many hours of dread, I, Edward, by God’s grace King of England, do entrust this deed conveying all revenues and rights of fee for the village of Glenbrae. By royal grant may Ronan MacLeod, my faithful man, collect wod-penny, agistment, foddercorn and chiminage, from now to his hour of death.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("Fine words for a village clinging desperately to life, one step away from starvation.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("MacLeod rubbed the only coins in his pockets, two silver French deniers. As they clinked hollowly, he tried to find excitement and satisfaction in a body hardened from months of travel and years of war.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("He did not look up as three dirty-faced children scrambled over the pitted street and stumbled to a halt before him. “’Tis the knight,” one muttered in the rippling Gaelic of the far North.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("“Aye. Blackhearted, he is, so my da says. And the knight does eat the hearts of wee children to break his fast.” The boys drew closer together, their eyes huge. At any second ")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("they expected the hard-faced Crusader to pounce upon them with his sword.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', [_vm._v("Ronan stared back, fingering his belt. Word of his hair-raising exploits in battle had spread along every dusty road from Damascus to Ghent. Even the court in London buzzed with the tales. And with each telling, the deeds became darker until the man called MacLeod became a monster with no shred of human feeling left.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', [_vm._v("Such tales had suited him full well, in truth. He seldom had need to raise his sword because his own black reputation had already done the work of conquest for him.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', [_vm._v("The scar that ran across his forehead usually did the rest.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', [_vm._v("The King’s Wolf, so he was called. A soldier who acted first and spared no time for regrets. A man who would master any woman foolish enough to tempt his embrace.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', [_vm._v("In spite of his grim reputation, the women had always found him, all too eager to taste the passion of a hardened soldier.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', [_vm._v("At first MacLeod had been happy to oblige. He had kissed them, stirred them, ridden them to noisy pleasure. He had seen the calculation in their eyes and felt it answer something in his own tortured heart.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', [_vm._v("But the novelty had faded. He began to feel defiled with each cold encounter, and the bitter taste in his mouth drove him to an uneasy abstinence. It had been longer than he could remember since he had touched a woman’s cheek, cupped the curve of a hip or breathed the fragrance of roses in silken hair.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', [_vm._v("MacLeod scowled at the frightened urchins huddled before him. “Begone,” he growled, tossing down a rumpled bit of linen in which he had wrapped a pigeon pie. Warily the boys studied the castaway food, suspecting some subtle treachery. The youngest of the three, little more than a bundle of bones, snatched up the pie and ran away, followed by his shrill companions.")])])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A fine homecoming indeed, the warrior thought darkly. Across the muddy road, he watched a pickpocket slip clever fingers into the leather pouch of a well-fed merchant. From the roof above rang an incomprehensible shout as brown sludge descended from a chamber pot, spraying the street.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Home. MacLeod began to wonder if the heathen East did not have its attractions after all.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("There was no escaping the curious gaze of the villagers busy about their work. He saw how the fathers stiffened at his approach and nudged their daughters out of sight. Even here the legends had spread.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("But it mattered not. He was their lord. They would obey him and offer him the respect he deserved. Whether they gave him any warmer sentiment was of no importance.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His young page shuffled restlessly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“What is it, Will?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“The manor house—it’s just over that hill. You wished to arrive before nightfall.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("In truth, the Crusader could summon little excitement for his new house or anything else. He had learned young that enthusiasm was an emotion best left to women and fools. But he felt a shred of sympathy for the weary boy beside him, who had been traveling for long, chill hours without complaint. “Do you know the way then, whelp?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Just past the wheelwright’s shop. I was told there is a path that leads through the orchard. The house is just beyond.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Then let us go and discover this fine grant the king has made to his best assassin.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Four men in tattered tunics sat along the path, their fishing lines angled into the clear water. At the sight of MacLeod, they scrambled awkwardly to their feet.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("MacLeod recognized the fear in their eyes. Yes, his legend had certainly spread here.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He rubbed his jaw and studied the layout of the pool. “Is there someone to organize the villeins for work here?”")])])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His page’s head bobbed. “The abbot has a way with the locals. Anything you want, he can arrange.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Then we’ll start here,” MacLeod said firmly. “We’ll add an outer ring of water and a new set of dikes. I’ll have sluice gates to control the flow of pike and eels. Tell the abbot the men of Glenbrae may fish here on Mondays. On all other days the pond is open only to women who are with child.” His face hardened. “From the looks of those I saw on the road, most will have little hope of living through the winter otherwise.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The page nodded. He, too, had seen the gaunt faces and undernourished bodies. “Shall I tell them it is at your order, my lord?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No. Tell them it is the command of their sovereign. Let King Edward take the credit and their gratitude.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The page made no protest, well used to his master’s eccentricities. As they trudged on, villagers gathered silently along the muddy path. The men looked apprehensive, and the women did not meet his gaze.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Not that MacLeod expected anything different. He was a native son gone too long among the Sassenach enemy. By the people of Glenbrae, he was neither trusted nor remembered.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Up the hill the warrior saw the dark stones of a grand tower house. Wooden shutters covered the dozen windows on the lower floors. Where the shutters lay open, MacLeod swore he saw true glazed casements, a sign of wealth beyond what he had expected.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Smoke curled lazily from the tall brick chimney, and the warrior felt a sudden tug at his heart. He had never had a proper home. After the long years of war, all he could remember was dusty roads and the sight of the next hill rising before him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Yet the prickling sense of uneasiness did not leave him, even here in the shadow of the grand tower house by the loch of Glenbrae. Home or not, something waited.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("And MacLeod sensed dangers yet to come….")])]), _c('p', {
    staticClass: "spaceBreak"
  }, [_c('span')])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "paraNoIndent"
  }, [_c('span', [_vm._v("S"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("UNLIGHT STRUCK")])]), _vm._v(" Perpetua’s heavy amber pendant as the images from the past swirled around her and slowly faded. She stood up, color spilling over her plain gray dress. “Oil and water, no doubt about it.” Mischief lit her striking green eyes. “But the fireworks between them should be absolutely "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("delicious.")])]), _vm._v("”")])])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page17"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ebd5a20","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/draycotteverlasting_ch01.vue
// module id = 75
// module chunks = 0